import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsDebugInfoOn } from 'selectors/debugInfoSelector';
import { setIsDebugModeOn } from 'reducers/debugInfoReducer';
import { useDebugPostMessages } from 'hooks/useDebugPostMessages';

export const useDebug = () => {
  const dispatch = useDispatch();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const debug = useMemo(() => (searchParams.get('debug') as string) ?? undefined, [searchParams]);
  const logPostMessages = debug === 'on';
  const isDebugInfoOn: boolean = useSelector(selectIsDebugInfoOn);

  // debug features:
  useDebugPostMessages();

  useEffect(() => {
    if (!logPostMessages) {
      return;
    }

    dispatch(setIsDebugModeOn(true));

    // eslint-disable-next-line no-console
    console.log('Debug Mode is Active!');
  }, [logPostMessages]);

  return logPostMessages || isDebugInfoOn;
};
